import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "salarii-wrapper" }
const _hoisted_2 = {
  key: 0,
  class: "luna-inchisa-banner"
}
const _hoisted_3 = { class: "salarii-row sal-top-1" }
const _hoisted_4 = { class: "left-block" }
const _hoisted_5 = { class: "salarii-row sal-top-2" }
const _hoisted_6 = { class: "act-btns" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DxSelectBox = _resolveComponent("DxSelectBox")!
  const _component_DxCheckBox = _resolveComponent("DxCheckBox")!
  const _component_DxButton = _resolveComponent("DxButton")!
  const _component_DxRadioGroup = _resolveComponent("DxRadioGroup")!
  const _component_DxSelection = _resolveComponent("DxSelection")!
  const _component_DxScrolling = _resolveComponent("DxScrolling")!
  const _component_DxFilterRow = _resolveComponent("DxFilterRow")!
  const _component_DxSorting = _resolveComponent("DxSorting")!
  const _component_DxPaging = _resolveComponent("DxPaging")!
  const _component_DxColumn = _resolveComponent("DxColumn")!
  const _component_DxDataGrid = _resolveComponent("DxDataGrid")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.lunaInchisa)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, " 🔒 Perioadă închisă (salarii " + _toDisplayString(_ctx.lunaSelectata) + "/" + _toDisplayString(_ctx.anulSelectat) + ") — vizualizare. Editarea și recalculul sunt blocate. ", 1))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _cache[6] || (_cache[6] = _createElementVNode("label", { class: "lbl ml-1" }, "Data:", -1)),
        _createVNode(_component_DxSelectBox, {
          items: _ctx.luni,
          modelValue: _ctx.lunaSelectata,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.lunaSelectata) = $event)),
          "display-expr": "text",
          "value-expr": "value",
          width: "120",
          onValueChanged: _ctx.getAngajati
        }, null, 8, ["items", "modelValue", "onValueChanged"]),
        _createVNode(_component_DxSelectBox, {
          items: _ctx.ani,
          modelValue: _ctx.anulSelectat,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.anulSelectat) = $event)),
          "display-expr": "text",
          "value-expr": "value",
          width: "120",
          onValueChanged: _ctx.getAngajati
        }, null, 8, ["items", "modelValue", "onValueChanged"]),
        _createVNode(_component_DxCheckBox, {
          modelValue: _ctx.rectificativ,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.rectificativ) = $event)),
          text: "Rectificativ"
        }, null, 8, ["modelValue"]),
        _createVNode(_component_DxCheckBox, {
          modelValue: _ctx.veziDetalii,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.veziDetalii) = $event)),
          text: "Vezi datele cu preluare automata",
          class: "ml-3",
          "enable-three-state-behavior": true,
          onValueChanged: _ctx.onVeziChanged
        }, null, 8, ["modelValue", "onValueChanged"])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _cache[7] || (_cache[7] = _createElementVNode("label", { class: "lbl ml-1" }, "Departament:", -1)),
        _createVNode(_component_DxSelectBox, {
          "data-source": _ctx.dsDepartamente,
          "display-expr": "Name",
          "value-expr": "ID",
          placeholder: "[selectați din listă]",
          width: "690",
          modelValue: _ctx.departamentSelectat,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.departamentSelectat) = $event)),
          "show-clear-button": true,
          onValueChanged: _ctx.onDepartamentChanged
        }, null, 8, ["data-source", "modelValue", "onValueChanged"])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_DxButton, {
          text: "Preluare date",
          type: "default",
          "styling-mode": "contained",
          icon: "runner",
          onClick: _ctx.preluareDate,
          disabled: _ctx.calcLoading || _ctx.lunaInchisa
        }, null, 8, ["onClick", "disabled"]),
        _createVNode(_component_DxButton, {
          text: "Calcul salarii",
          type: "success",
          "styling-mode": "contained",
          icon: "money",
          onClick: _ctx.calculSalarii,
          disabled: _ctx.calcLoading || _ctx.lunaInchisa
        }, null, 8, ["onClick", "disabled"]),
        _createVNode(_component_DxButton, {
          text: "Simulare sal.",
          type: "default",
          "styling-mode": "contained",
          icon: "pulldown",
          onClick: _ctx.simulareSalarii
        }, null, 8, ["onClick"]),
        _createVNode(_component_DxButton, {
          text: "Inchide salarii",
          type: "danger",
          "styling-mode": "contained",
          icon: "close",
          disabled: _ctx.lunaInchisa || _ctx.calcLoading,
          onClick: _ctx.inchideSalarii
        }, null, 8, ["disabled", "onClick"])
      ]),
      _createVNode(_component_DxRadioGroup, {
        items: ['Angajati', 'Companie', 'Valori implicite'],
        layout: "horizontal",
        modelValue: _ctx.modPreluare,
        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.modPreluare) = $event)),
        onValueChanged: _ctx.onModeChanged
      }, null, 8, ["modelValue", "onValueChanged"])
    ]),
    _createElementVNode("div", {
      class: _normalizeClass([{ 'disabled-grid': _ctx.modPreluare !== 'Angajati' }, "emp-grid-holder"])
    }, [
      _createVNode(_component_DxDataGrid, {
        class: "salarii-grid",
        "data-source": _ctx.dsActiveEmployees,
        "key-expr": "Id",
        "show-borders": true,
        "show-row-lines": true,
        "row-alternation-enabled": true,
        "allow-column-reordering": true,
        "allow-column-resizing": true,
        "column-resizing-mode": 'nextColumn',
        "hover-state-enabled": true,
        "focused-row-enabled": true,
        "focused-row-index": 0,
        "column-auto-width": false,
        width: "100%",
        height: "100%",
        onSelectionChanged: _ctx.onSelectionChanged
      }, {
        default: _withCtx(() => [
          _createVNode(_component_DxSelection, { mode: "single" }),
          _createVNode(_component_DxScrolling, { mode: "standard" }),
          _createVNode(_component_DxFilterRow, { visible: true }),
          _createVNode(_component_DxSorting, { mode: "multiple" }),
          _createVNode(_component_DxPaging, { enabled: false }),
          _createVNode(_component_DxColumn, {
            "data-field": "InternalCode",
            caption: "Cod",
            width: "80"
          }),
          _createVNode(_component_DxColumn, {
            "data-field": "Name",
            caption: "Nume"
          }),
          _createVNode(_component_DxColumn, {
            "data-field": "Surname",
            caption: "Prenume"
          }),
          _createVNode(_component_DxColumn, {
            "data-field": "GrupNume",
            caption: "Grup"
          })
        ]),
        _: 1
      }, 8, ["data-source", "onSelectionChanged"])
    ], 2)
  ]))
}